<template>
  <div>
    <div class="infoInner">
      <div class="infoTitle">
        <h1>프로필 정보</h1>
      </div>
    </div>
    <div class="profileImgBox">
      <div class="profileImgInputBox preview-image">
        <img :src="imageUrl" alt="" class="upload-name" />
        <!-- <input  disabled="disabled" :style="`background-image:url(${imageUrl});`"> -->
        <label for="input-file"></label>
        <input
          type="file"
          id="input-file"
          class="upload-hidden"
          @change="setFileImage"
        />
      </div>
    </div>
    <div class="container">
      <div class="infoContain">
        <div>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(saveProfile)"
            >
              <div class="flex mobileFlex">
                <div class="inputBox infoBox wd50">
                  <label>아이디<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.id" maxlength="20" disabled />
                </div>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="이메일"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <label>이메일<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.email" maxlength="40" />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="비밀번호"
                  rules="pw"
                  vid="비밀번호"
                  v-slot="{ errors }"
                >
                  <label
                    >비밀번호 (특수문자 포함, 8자리 이상)<span class="labelItem"
                      >*</span
                    ></label
                  >
                  <input
                    type="password"
                    v-model="signupInfo.password"
                    maxlength="16"
                    autocomplete="new-password"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="휴대폰번호"
                  rules="required|mobileTel"
                  v-slot="{ errors }"
                >
                  <label>휴대폰 번호<span class="labelItem">*</span></label>
                  <input
                    v-model="signupInfo.phoneNumber"
                    @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                    maxlength="11"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="비밀번호 재확인"
                  rules="confirmed:@비밀번호"
                  vid="비밀번호 재설정"
                  v-slot="{ errors }"
                >
                  <label
                    >비밀번호 확인 (한번 더 입력해주세요.)<span
                      class="labelItem"
                      >*</span
                    ></label
                  >
                  <input
                    type="password"
                    v-model="confirmedPassword"
                    maxlength="16"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="이름"
                  rules="required|name"
                  v-slot="{ errors }"
                >
                  <label>이름<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.name" maxlength="16" />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <div class="inputBox infoBox wd50">
                  <label>성별<span class="labelItem">*</span></label>
                  <div class="bspRadio">
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                        id="btn-radios-1"
                        v-model="signupInfo.gender"
                        :options="genderOptions"
                        :aria-describedby="ariaDescribedby"
                        name="radios-btn-default"
                        buttons
                      ></b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="생년월일"
                  rules="required|dateNoHyphen"
                  v-slot="{ errors }"
                >
                  <label>생년월일<span class="labelItem">*</span></label>
                  <input
                    v-model="signupInfo.birthday"
                    maxlength="10"
                    placeholder="YYYYMMDD"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <Address
                :signupInfo="signupInfo"
                :childDataLoaded="childDataLoaded"
                @set-address="setAddress"
              />

              <div class="warningInfo">
                <p>
                  위의 항목 중 수정을 원하는 항목을 클릭하시고 새로 수정할
                  정보를 입력하세요. <br />
                  정보입력 후 아래의 수정버튼을 누르시면 회원정보 수정이
                  진행됩니다.
                </p>
              </div>

              <div class="btnBox flex">
                <button
                  type="button"
                  class="btnFont redborderBtn"
                  @click="onClickBeforeBtn"
                >
                  취 소
                </button>
                <button type="submit" class="btnFont redBtn">수 정</button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Address from "@/components/join/Address";
import * as eventUtil from "@/utils/eventUtil";
import axios from "@/axios/axios";
import { mapActions } from "vuex";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    Address,
  },
  data() {
    return {
      childDataLoaded: false,
      eventUtil: eventUtil,
      signupInfo: {
        roleName: this.$role.USER,
        id: "",
        password: "",
        name: "",
        email: "",
        phoneNumber: "",
        birthday: "",
        address: "",
        addressDetail: "",
        gender: "M",
      },
      checkedId: "", // 중복검사 완료된 아이디
      checkedPhoneNumber: "", // 인증을 요청한 전화번호
      confirmedPassword: "", // 비밀번호 재확인 값
      isVerified: false, // 전화번호 인증 여부
      verifyNumber: "", // 인증번호
      counter: 0, // 인증번호 유효 시간 카운터
      counterPlaceHolder: "", // 인증번호 유효 시간 카운터(출력용)
      addr1: "", // addressFind util 주소검색 결과
      postcode: "", // addressFind util 주소검색 결과(우편번호)
      genderOptions: [
        { text: "남", value: "M" },
        { text: "여", value: "F" },
      ],
      selected: "man",
      options: [
        { text: "남", value: "man" },
        { text: "여", value: "woman" },
      ],
      imageUrl: require("@/assets/images/user/imgEnroll.png"),
      file: null,
      idx: null,
    };
  },
  created() {
    var idx = this.$route.params.idx;

    this.requestUserDetail(idx)
      .then((response) => {
        if (response.status == 200) {
          let user = response.data.USER;
          this.signupInfo.id = user.id;
          this.signupInfo.email = user.email;
          this.signupInfo.phoneNumber = user.phoneNumber;
          this.signupInfo.name = user.name;
          this.signupInfo.birthday = user.birthday;
          this.signupInfo.gender = user.gender;
          this.signupInfo.address = user.address;
          this.signupInfo.addressDetail = user.addressDetail;
          this.imageUrl = user.saveFileName;

          this.childDataLoaded = true;
        }
      })
      .catch(() => {
        this.$alert("알림", "2단계 카테고리 데이터를 가져올 수 없습니다.");
      });
  },
  computed: {},
  methods: {
    ...mapActions("user", ["requestUserDetail"]),
    onClickBeforeBtn() {
      this.$router.push({ path: "/admin/accountManagement" });
    },
    setFileImage(event) {
      let file = event.target.files[0];
      let fileName = event.target.files[0].name;

      let fileNameArr = fileName.split(".");
      let ext = fileNameArr[fileNameArr.length - 1];

      let checkExts = [
        "gif",
        "png",
        "jpg",
        "jpeg",
        "GIF",
        "PNG",
        "JPG",
        "JPEG",
      ];

      let check = checkExts.some(function(checkExt) {
        return ext === checkExt;
      });

      if (!check) {
        this.$alert(
          "알림",
          "업로드가 불가한 확장자입니다. <br>(gif, png, jpg, jpeg 파일만 업로드할 수 있습니다.)"
        );
        return;
      }

      if (file.size >= 1024 * 1024 * 10) {
        this.$alert("알림", "첨부파일은 10mb이하의 크기만 업로드 가능합니다.");
        return;
      }

      this.file = file;
      this.imageUrl = URL.createObjectURL(this.file);
    },
    getUserInfo() {
      var idx = this.$route.params.idx;

      axios
        .post("/api/profile/getProfileInfo", idx)
        .then((response) => {
          if (response.status == 200) {
            let user = response.data.USER;
            this.signupInfo.id = user.id;
            this.signupInfo.email = user.email;
            this.signupInfo.phoneNumber = user.phoneNumber;
            this.signupInfo.name = user.name;
            this.signupInfo.birthday = user.birthday;
            this.signupInfo.gender = user.gender;
            this.signupInfo.address = user.address;
            this.signupInfo.addressDetail = user.addressDetail;
            this.imageUrl = user.saveFileName;

            this.childDataLoaded = true;
          }
        })
        .catch((error) => {
          this.$alert(
            "알림",
            "상세정보를 불러오는 중 에러가 발생했습니다. 관리자에게 문의해주세요.<br>" +
              error.response.data.error
          );
        });
    },
    saveProfile() {
      let idx = this.$route.params.idx;

      const formData = new FormData();
      if (idx) {
        formData.append("IDX", idx);
      }
      formData.append("THUMBNAIL_IMG", this.file);
      formData.append("PASSWORD", this.signupInfo.password);
      formData.append("EMAIL", this.signupInfo.email);
      formData.append("PHONE_NUMBER", this.signupInfo.phoneNumber);
      formData.append("NAME", this.signupInfo.name);
      formData.append("BIRTHDAY", this.signupInfo.birthday);
      formData.append("GENDER", this.signupInfo.gender);
      formData.append("ADDRESS", this.signupInfo.address);
      formData.append("ADDRESS_DETAIL", this.signupInfo.addressDetail);

      var response = this.$createConfirmResponse();
      this.$confirm(
        "알림",
        "회원정보 수정 시 기존의 정보는 삭제되고 새로 입력하신 정보로 변경됩니다. 그래도 입력하신 부분의 정보수정을 진행하시겠습니까?",
        "확인",
        "취소",
        response,
        {
          closed: () => {
            if (response.result) {
              axios
                .post("/api/profile/update", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((result) => {
                  if (result.status == 200) {
                    this.$alert("알림", "회원정보가 수정되었습니다.", "확인", {
                      closed: () => {
                        this.$router.push({ path: "/admin/accountManagement" });
                      },
                    });
                  }
                })
                .catch((error) => {
                  this.$alert(
                    "알림",
                    "회원정보 수정 중 에러가 발생했습니다. 관리자에게 문의해주세요. <br>" +
                      error
                  );
                });
            }
          },
        }
      );
    },
    setAddress(address, addressDetail) {
      this.signupInfo.address = address;
      this.signupInfo.addressDetail = addressDetail;
    },
  },
};
</script>

<style scoped>
.infoInner > .infoTitle {
  padding: 0 100px;
}
.infoInner > div > h1 {
  color: #9e1915;
}
input:disabled {
  color: #7d7d7d;
}
.profileImgBox {
  padding: 40px 0;
  text-align: center;
}
.profileImgInputBox {
  position: relative;
}
.profileImgInputBox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.profileImgInputBox label:active {
  transform: scale(0.97);
}
.profileImgInputBox label {
  position: absolute;
  z-index: 1;
  width: 190px;
  height: 190px;
  color: #fff;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: transparent;
  cursor: pointer;
  left: 50%;
  margin-left: -95px;
}
.profileImgInputBox .upload-name {
  border: 0;
  display: inline-block;
  width: 190px;
  height: 190px;
  padding: 6px 20px 5px; /* label의 패딩값과 일치 */
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-size: 80%;
  background-position: center;
  /* background-image: url('../../../assets/images/user/imgEnroll.png'); */
  -webkit-appearance: none; /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  appearance: none;
}
/* preview img */
.filebox .upload-display {
  /* 이미지가 표시될 지역 */
  margin-bottom: 5px;
}
@media (min-width: 768px) {
  .filebox .upload-display {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 0;
  }
}
.filebox .upload-thumb-wrap {
  /* 추가될 이미지를 감싸는 요소 */
  display: inline-block;
  width: 54px;
  padding: 2px;
  vertical-align: middle;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
}
.filebox .upload-display img {
  /* 추가될 이미지 */
  display: block;
  max-width: 100%;
  width: 100% \9;
  height: auto;
}
</style>

<style scoped lang="scss">
.bspRadio ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
.bspSelectBox ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
</style>
